import { DefaultTheme } from 'styled-components'
import { Color } from 'styles/types'
import { Wrapper } from './styles'
import { IconSize, IconVariant } from './types'

interface IconProps {
    variant: IconVariant
    size?: IconSize | [IconSize, IconSize]
    rotation?: number
    color?: Color
    isSpinning?: boolean
    theme?: DefaultTheme
}

const defaultIconSize: IconSize = 24

const Icon = ({
    variant,
    size = defaultIconSize,
    rotation,
    color,
    isSpinning,
    theme,
}: IconProps) => (
    <Wrapper
        size={size}
        className={`icon-${variant}`}
        rotation={rotation}
        color={color}
        isSpinning={isSpinning}
        theme={theme}
    ></Wrapper>
)

export default Icon
